import {COLORS, StyledLogoText} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {AboutYouLogoProps} from '../../features/AboutYouLogo/AboutYouLogo';
import {HeaderAboutYouLogoWrapper} from './AboutYouLogo/HeaderAboutYouLogoWrapper';
import {GenderSwitch} from './GenderSwitch/GenderSwitch';
import {EnableSettingsModalProps} from './IconMetaNavigation/IconMetaNavigationItemUser/FlyoutLoggedIn';
import {IconMetaNavigationItems} from './IconMetaNavigation/IconMetaNavigationItems';
import {RowSectionStyled} from './RowSectionStyled';
import {TOP_ROW_HEIGHT} from './constants';

interface HeaderTopRowContainerProps {
  enableSettingsModalComponent: (
    props: EnableSettingsModalProps,
  ) => React.ReactNode;
  notificationBellRef: React.RefObject<HTMLDivElement>;
}

export const HeaderTopRowContainer: React.FC<HeaderTopRowContainerProps> = ({
  enableSettingsModalComponent,
  notificationBellRef,
}) => {
  return (
    <Wrapper data-testid="headerTopRowContainer">
      <TopRowContents>
        <StyledGenderSwitch />
        <StyledHeaderAboutYouLogoWrapper />
        <StyledIconMetaNavigationItems
          enableSettingsModalComponent={enableSettingsModalComponent}
          notificationBellRef={notificationBellRef}
        />
      </TopRowContents>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: ${TOP_ROW_HEIGHT}px;
  border-bottom: 1px solid ${COLORS.Grey4};
`;

const TopRowContents = styled(RowSectionStyled)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: ${TOP_ROW_HEIGHT}px;
  margin: auto;
`;

const StyledGenderSwitch = styled(GenderSwitch)`
  flex: 1 2 33%;
`;

/**
 * This breakpoint is specific for the new header since the top row
 * contains more elements than the old header, we run into overflow-issues
 * with longer first names. The maximum amount of characters display is 18
 * (see: packages/core/ui-components/src/components/organisms/AboutYouMainLogo/AdditionalLogos/AboutNameLogo/AboutNameTextLogo.tsx).
 *
 * Above 805px width it is fine to display the full name, below that we need
 * to truncate it.
 */
const mediaMaxAYLogo = `only screen and (max-width: 805px)`;

// The tests are mocking many apis which does not work well in jest with circular dependencies. Deferring the logo fixes it.
const DeferredLogoWrapper: React.FC<AboutYouLogoProps> = props => (
  <HeaderAboutYouLogoWrapper {...props} />
);
const StyledHeaderAboutYouLogoWrapper = styled(DeferredLogoWrapper)`
  ${StyledLogoText} {
    @media ${mediaMaxAYLogo} {
      display: block;
      text-overflow: ellipsis;
      max-width: 220px;
      overflow: hidden;
    }
  }
`;

const StyledIconMetaNavigationItems = styled(IconMetaNavigationItems)`
  flex: 1 1 33%;
`;
